import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Button, Container, Grid } from 'semantic-ui-react';
import Utils from 'utils/Utils.js';

import {colors, shadow, fontSizes, fonts, spacings, buttons} from 'style';

import styleDef from './style.js';

var style = {
    ...styleDef,
    row: {
        backgroundColor: 'white',
    },
    body: {
        maxWidth: '500px',
    },
    welcome: {
        fontSize: fontSizes.h2,
        color: colors.themeBlue,
        lineHeight: '2',
    },
    companyLogo: {
        height: '100px',
        marginTop: spacings.large,
        marginBottom: spacings.large,
        backgroundPosition:'50% 50%', 
        backgroundSize:'contain',
        backgroundRepeat: 'no-repeat',
    },
    message: {
        position: 'relative',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        wordWrap:'break-word', 
        whiteSpace:'pre-wrap',
        boxShadow: shadow,
        borderRadius: '10px',
    },
    messageContent: {
        padding: '50px',
        boxShadow: 'none',
    },
    messagePointer: {
        backgroundColor: 'inherit',
        position: 'absolute',
        bottom: '0px',
        left: '50%',
        marginBottom: '-12px',
        marginLeft: '-12px',
        width: '24px',
        height: '24px',
        transform: 'rotate(45deg)',
        boxShadow: 'inherit',
    },
    photoWrapper: {
        padding: '30px 0px 20px 0px',
    },
    photo:{
        position: 'relative',
        display: 'inline-block',
        width:'4em', 
        height:'4em', 
        borderRadius:'50%',
        border: '2px solid #fff',
        boxShadow: shadow,
        top: '1em',
        marginRight: '20px',
    },
    photoText: {
        display: 'inline-block',
        textAlign: 'left',
    },
    welcomerName: {
        fontWeight: 'bold',
    },
    welcomerTitle: {
        fontStyle: 'italic',
    },
    tealButton: {
        ...buttons.long,
        backgroundColor: colors.themeTeal,
    },
}

const Welcome = ({t, welcome, userProfile, title, next, buttonLabel}) => (
    <div style={style.container}>
        <div style={style.containerDiv}>
            <div style={style.segment}>
                <Grid style={style.grid} textAlign="center">
                    <Grid.Row style={style.row}> 
                        <Grid.Column verticalAlign="top" style={style.body}>
                            {Boolean(userProfile && userProfile.firstName && userProfile.firstName.length>0) ? (
                                    <div style={style.welcome}>{t('Welcome, {{name}}!', {name:userProfile.firstName})}</div>
                                ) : (
                                    <div style={style.welcome}>{title || t('Welcome!')}</div>
                                )
                            }
                            {Boolean(welcome.logo && welcome.logo.url) &&
                                <div style={{...style.companyLogo, backgroundImage:Utils.url(welcome.logo.url)}} />
                            }
                            <div style={style.message}>
                                <div style={style.messagePointer} />
                                <div style={{...style.message, ...style.messageContent}}>
                                    {welcome.message}
                                </div>
                            </div>
                            <div style={style.photoWrapper}>
                                {Boolean(welcome.photo && welcome.photo.url) &&
                                    <img style={style.photo} src={welcome.photo.url} alt="" />
                                }
                                <span style={style.photoText}>
                                    <div style={style.welcomerName}>{welcome.welcomerName}</div>
                                    <div style={style.welcomerTitle}>{welcome.welcomerTitle}</div>
                                </span>
                            </div>
                        </Grid.Column>
                    </Grid.Row> 
                    <Grid.Row style={style.row}> 
                        <Grid.Column verticalAlign="bottom" textAlign='center'>
                            <Button style={style.tealButton} onClick={()=>{next()}}>{buttonLabel || t('Build Your Profile')}</Button>
                        </Grid.Column>
                    </Grid.Row> 
                </Grid>
            </div> 
        </div> 
    </div> 
);

export default translate('onboarding')(Welcome);



// WEBPACK FOOTER //
// ./src/modules/onboarding/Welcome.js